export const AddCourseStepsBuckets: Record<number, string[]> = {
  0: [
    'name',
    'description',
    'content',
    'targetAudience',
    'confirmationForm',
    'learningMethod',
    'instructors', // handles validation for array
    'startDate',
    'endDate',
    'price',
    'externalUrl',
    'canBeReimbursed',
    'requiresExam',
  ],
};
